import React from "react";
import PropTypes from "prop-types";
import NuSingleSelect from "js/components/NuSingleSelect";
import Api from "js/api/authorisedApi";
import StandardModal from "js/components/shared/StandardModal";
import moment from "moment";
import { PrimaryButton } from "../shared/button/PrimaryButton";
import { useClassroomPolicyStore } from "stores/v2/classroomPolicyStore";

class BypassModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bypassActiveUntil: 0,
			creationTime: 0,
			timeframe: "600",
			bypassActive: false,
			loadingCode: false,
			stoppingCode: false,
			addingCode: false,
			code: undefined,
			id: undefined,
		};
	}

	componentDidMount = () => {
		this.timer = setInterval(this.bypassTimer, 1000);
		this.getBypassCode();
	};

	componentWillUnmount = () => {
		clearInterval(this.timer);
	};

	getBypassCode() {
		const now = moment().unix();

		Api.get("/backend/classroom/bypass_code", (result) => {
			const last = result["result"][0];

			if (last && last.expiry_time >= now) {
				this.setState({
					code: last.code,
					bypassActiveUntil: last.expiry_time,
					creationTime: last.creation_time,
					id: last.id,
				});
			} else {
				this.generateCode();
			}
		});
	}

	generateCode() {
		if (!this.state.code) {
			this.setState({ loadingCode: true });
			Api.get(
				"/backend/classroom/bypass_code/generate",
				(result) => {
					if (result["result"]) {
						setTimeout(() => {
							this.setState({
								code: result["result"],
								loadingCode: false,
							});
						}, 0);
					}
				},
				() => {
					this.setState({ loadingCode: false });
				}
			);
		}
	}

	reset = () => {
		this.setState(
			{
				bypassActiveUntil: 0,
				creationTime: 0,
				timeframe: "600",
				code: undefined,
				stoppingCode: false,
			},
			() => this.generateCode()
		);
	};

	//! event is undefined if this function is trigerred by enter key listener in Dialog
	startBypass = (event) => {
		this.setState({ addingCode: true });

		const activeUntil = moment().unix() + parseInt(this.state.timeframe);
		const creationTime = moment().unix();

		/* eslint-disable camelcase */
		const bypass = {
			code: this.state.code,
			creation_time: creationTime,
			expiry_time: activeUntil,
		};
		/* eslint-enable camelcase */

		Api.post(
			"/backend/classroom/bypass_code",
			bypass,
			() => {
				this.setState({
					bypassActiveUntil: activeUntil,
					creationTime: creationTime,
					addingCode: false,
				});

				useClassroomPolicyStore.getState().setBypassActiveUntil(activeUntil);

				this.getBypassCode();
				this.close();
			},
			() => {
				this.setState({
					addingCode: false,
				});
			}
		);
	};

	//! event is undefined if this function is trigerred by enter key listener in Dialog
	stopBypass = () => {
		this.setState({
			stoppingCode: true,
		});

		const now = moment().unix();

		/* eslint-disable camelcase */
		const bypass = {
			code: this.state.code,
			creation_time: this.state.creationTime,
			expiry_time: now,
			id: this.state.id,
		};
		/* eslint-enable camelcase */

		Api.post("/backend/classroom/bypass_code/update", bypass, (result) => {
			useClassroomPolicyStore.getState().setBypassActiveUntil(now);
			this.reset();
			this.close();
		});
	};

	close = () => {
		this.props.onClose();
	};

	prepareBypassDuration = () => [
		{ value: "600", text: "10 Minutes" },
		{ value: "900", text: "15 Minutes" },
		{ value: "1200", text: "20 Minutes" },
		{ value: "1800", text: "30 Minutes" },
		{ value: "2700", text: "45 Minutes" },
		{ value: "3600", text: "1 Hour" },
		{ value: "7200", text: "2 Hours" },
		{ value: "10800", text: "3 Hours" },
	];

	changeBypassDuration = (value) => {
		this.setState({
			timeframe: value,
		});
	};

	bypassTimer = () => {
		const bypassActive = this.state.bypassActiveUntil > moment().unix();
		const end = moment.utc(this.state.bypassActiveUntil, "X");
		const timeLeft = moment.utc(end.diff(moment.utc()));

		if (this.state.bypassActive !== bypassActive) {
			this.setState({
				bypassActive,
				bypassTimeLeft: timeLeft.hours() + " hours " + timeLeft.minutes() + " minutes",
			});
			if (this.props.isActive) {
				this.props.isActive(bypassActive);
			}
		}
		const bypassTTL = document.getElementById("bypassTimeLeft");
		if (bypassTTL) {
			bypassTTL.innerText = timeLeft.format("HH:mm:ss");
		}
	};

	renderBypassButton = () => {
		let stopLabel = "Stop";
		let startLabel = "Start";
		let disabled = false;

		if (this.state.stoppingCode) {
			stopLabel = "Stopping Bypass";
			disabled = true;
		} else if (this.state.addingCode) {
			startLabel = "Starting Bypass";
			disabled = true;
		}

		if (this.state.bypassActive) {
			return <PrimaryButton className="mui-flat-button" label={stopLabel} onClick={this.currentBypassHandler()} disabled={disabled} />;
		} else {
			return <PrimaryButton className="mui-flat-button" label={startLabel} onClick={this.currentBypassHandler()} disabled={disabled} />;
		}
	};

	currentBypassHandler = () => {
		if (this.state.bypassActive) {
			return this.stopBypass;
		} else {
			return this.startBypass;
		}
	};

	renderButtons = () => {
		return <React.Fragment>{this.renderBypassButton()}</React.Fragment>;
	};

	renderTimeSelection = () => {
		if (this.state.bypassActive) {
			return (
				<div>
					<div className="BypassModal_title">Time Left</div>
					<div className="BypassModal_time">
						<span id={"bypassTimeLeft"} /> ({moment(this.state.bypassActiveUntil, "X").format("LLL")})
					</div>
				</div>
			);
		} else {
			return (
				<NuSingleSelect
					allItems={this.prepareBypassDuration()}
					selectedItem={this.state.timeframe}
					searchPlaceholder="Bypass Duration"
					title="Bypass Duration"
					onChange={this.changeBypassDuration}
				/>
			);
		}
	};

	renderCode = () => {
		return (
			<div>
				<div className="BypassModal_title">Bypass Code</div>
				<div className="BypassModal_code">{this.state.code ? this.state.code : "----"}</div>
			</div>
		);
	};

	render() {
		return (
			<StandardModal title="Bypass Code" actions={this.renderButtons()} open={this.props.open} close={this.close}>
				<form onSubmit={(ev) => ev.preventDefault()}>
					<div className="BypassModal_duration">{this.renderTimeSelection()}</div>
					<div>{this.renderCode()}</div>
				</form>
			</StandardModal>
		);
	}
}

BypassModal.propTypes = {
	isActive: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default BypassModal;
